/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import TransactionsSkeleton from '@components/Transactions/Transactions.skeleton';
import TransactionTableGral from '@components/Transactions/TransactionTableGral';
import TransactionTableOnus from '@components/Transactions/TransactionTableOnus';
import Pagination from '@components/Paginate';
import { useAuth, useTransaction } from '@hooks';

import NoMovementsCalendarTransactions from '@components/NoMovementsCalendar';
import { useHistory } from 'react-router';
import * as Routes from '@constants/routes';
import { NoMovementsTransactions } from '@components';
import { useNearScreen } from 'hooks';
import { useBreakpoints } from '@hooks/NewBreakpoint';
import styled, { css } from 'styled-components';
import TransactionCardSkeleton from '@components/Transactions/TransactionCard/TransactionCard.skeleton';

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TextFooter = styled.div(
  ({ theme }) => css`
    ${({ theme }) => theme.textTypes['Caption-w400']};

    color: ${theme.colors.gray700};
    text-align: center !important;
    padding: 16px 0;
    max-width: 304px;
  `
);

const TransactionsWeb = ({ falabella }) => {
  const { t } = useTranslation();
  const { isOnus } = useAuth();
  const {
    isLoadingTransactions,
    errorTransactions,
    transactions,
    pagination: { currentPage, itemsTotal, perPage },
    changedPagination,
    getTransactions,
    moreTransactions,
    isLimitMobile,
    pagination,
  } = useTransaction();

  const handlePage = (currentPage) => changedPagination({ currentPage });

  useEffect(() => {
    getTransactions();
  }, []);

  const history = useHistory();
  const externalRef = useRef();
  const { isNearScreen } = useNearScreen({ externalRef, once: false });

  const handleMoreItems = () => {
    if (!isLimitMobile()) moreTransactions();
  };

  useEffect(() => {
    if (isNearScreen) {
      handleMoreItems();
    }
  }, [isNearScreen]);

  const { breakpoint } = useBreakpoints();

  return (
    <>
      {isLoadingTransactions ? (
        <TransactionsSkeleton falabella={falabella} />
      ) : (
        <>
          {errorTransactions ? (
            <NoMovementsCalendarTransactions
              text1={t('transactions.noTransactions.textError')}
              title={t('transactions.noTransactions.titleError')}
              image="errorconection.svg"
              withButton={false}
            />
          ) : transactions.length > 0 ? (
            <>
              {isOnus ? (
                <TransactionTableOnus dataTable={transactions} />
              ) : (
                <TransactionTableGral dataTable={transactions} />
              )}

              {['xs'].includes(breakpoint) ? (
                <>
                  {pagination.itemsTotal !== transactions.length && (
                    <div id="visor" ref={externalRef} />
                  )}
                  {pagination.itemsTotal === transactions.length && (
                    <Footer>
                      <TextFooter>{t('transactionsFalabella.noMoreTransactions')}</TextFooter>
                    </Footer>
                  )}
                  {isLoadingTransactions && (
                    <>
                      <TransactionCardSkeleton />
                      <TransactionCardSkeleton />
                    </>
                  )}
                </>
              ) : (
                <Pagination
                  currentPage={currentPage}
                  totalRecord={itemsTotal}
                  recordPerPage={perPage}
                  data-testid="component-pagination"
                  goToPage={handlePage}
                />
              )}
            </>
          ) : (
            <NoMovementsTransactions
              title={t('transactionsFalabella.emptyStateTitleFC')}
              image="ils-shop.svg"
              outlined
              text1={t('transactionsFalabella.emptyStateSubTitleFC')}
              withButton
              textButton={t('transactionsFalabella.emptyStateFCButton')}
              onClickButton={() => history.push(Routes.SELLER_HOME)}
            />
          )}
        </>
      )}
    </>
  );
};

export default TransactionsWeb;
